export default "__VITE_ASSET__BRzV1ZEu__"